import _createForOfIteratorHelper from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _toConsumableArray from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module alignment/alignmentediting
 */

import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import AlignmentCommand from './alignmentcommand';
import { isDefault, isSupported, supportedOptions } from './utils';

/**
 * The alignment editing feature. It introduces the {@link module:alignment/alignmentcommand~AlignmentCommand command} and adds
 * the `alignment` attribute for block elements in the {@link module:engine/model/model~Model model}.
 * @extends module:core/plugin~Plugin
 */
var AlignmentEditing = /*#__PURE__*/function (_Plugin) {
  /**
   * @inheritDoc
   */
  function AlignmentEditing(editor) {
    var _this;
    _classCallCheck(this, AlignmentEditing);
    _this = _callSuper(this, AlignmentEditing, [editor]);
    editor.config.define('alignment', {
      options: _toConsumableArray(supportedOptions)
    });
    return _this;
  }

  /**
   * @inheritDoc
   */
  _inherits(AlignmentEditing, _Plugin);
  return _createClass(AlignmentEditing, [{
    key: "init",
    value: function init() {
      var editor = this.editor;
      var locale = editor.locale;
      var schema = editor.model.schema;

      // Filter out unsupported options.
      var enabledOptions = editor.config.get('alignment.options').filter(isSupported);

      // Allow alignment attribute on all blocks.
      schema.extend('$block', {
        allowAttributes: 'alignment'
      });
      editor.model.schema.setAttributeProperties('alignment', {
        isFormatting: true
      });
      var definition = _buildDefinition(enabledOptions.filter(function (option) {
        return !isDefault(option, locale);
      }));
      editor.conversion.attributeToAttribute(definition);
      editor.commands.add('alignment', new AlignmentCommand(editor));
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'AlignmentEditing';
    }
  }]);
}(Plugin); // Utility function responsible for building converter definition.
// @private
export { AlignmentEditing as default };
function _buildDefinition(options) {
  var definition = {
    model: {
      key: 'alignment',
      values: options.slice()
    },
    view: {}
  };
  var _iterator = _createForOfIteratorHelper(options),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var option = _step.value;
      definition.view[option] = {
        key: 'style',
        value: {
          'text-align': option
        }
      };
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return definition;
}